const initialState = {};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'table.plan_setting_templates/SET_TABLE_PARAMS':
      return {
        ...state,
        ...action.params,
      };
    case 'table.plan_setting_templates/LIST_PLAN_SETTING_TEMPLATES_SUCCESS':
      return {
        ...state,
        data: action.response.data,
        filters: action.response.filters,
        ...action.response.pagination,
      };

    case 'table.plan_setting_templates/READ_PLAN_SETTING_TEMPLATE_SUCCESS':
      return {
        ...state,
        flyout: action.response.data,
      };

    default:
      return state;
  }
}
